import { Web3Model } from "../../../../../../web3/models/Web3Model";
import { ISignOutController } from "./ISignOutController";
import { injectable } from "@launchtray/tsyringe-async";

@injectable()
export class SignOutController implements ISignOutController {
    public constructor(private readonly web3Model: Web3Model) {
    }

    public async signOut(): Promise<void> {
        await this.web3Model.disconnect();
    }
}
